import { render, staticRenderFns } from "./DialogsTesting.vue?vue&type=template&id=c2a142aa"
import script from "./DialogsTesting.vue?vue&type=script&lang=js"
export * from "./DialogsTesting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports